/**
 * Report rows name items by id; screens show the item's name and link to its page. Items no longer
 * in the Library (deleted since they were watched) keep a plain name and no link.
 */

import { useMemo } from "react";
import type { EntitySummary } from "@/api/admin";
import { href, itemRoute } from "@/lib/route";
import type { RangeDays } from "./range";

export interface ItemRef {
  label: string;
  /** The item's page, on its Analytics tab. */
  href?: string;
  type?: EntitySummary["type"];
}

export function useItemNames(brand: string, items: readonly EntitySummary[] | null, range?: RangeDays): (id: string) => ItemRef {
  return useMemo(() => {
    const byId = new Map((items ?? []).filter((e) => e.type === "title" || e.type === "liveEvent" || e.type === "series").map((e) => [e.id, e]));
    return (id: string) => {
      const e = byId.get(id);
      if (!e) return { label: items ? `Removed from your Library (${id})` : id };
      return { label: e.label || "(no name)", type: e.type, href: href({ ...itemRoute(brand, e.type, e.id), tab: "analytics", ...(range ? { range } : {}) }) };
    };
  }, [brand, items, range]);
}
